// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sourcing[data-v-bbe70bc0]{background-color:rgba(27,120,216,.2)}.kfi[data-v-bbe70bc0]{background-color:rgba(30,176,225,.2)}.application[data-v-bbe70bc0]{background-color:rgba(103,0,86,.2)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
